import React from 'react';
import Greetings from '../components/Greetings';
import ItemPicker from '../components/ItemPicker';
class Home extends React.Component {

  constructor (props) {
    super(props);

    this.state = {
      error : '',
      query: this.props.query,
      firstTime : this.props.query.location.search.length == 0
    };


    this.handler = this.handler.bind(this)
  }


  handler(){
    this.setState({firstTime : !this.state.firstTime})
    console.log('handler')
  }

componentDidUpdate(prevProps){
"it updated"
}

componentDidMount(){

if(this.state.query.location.key !=null){
  this.setState({firstTime:false})
}

if(this.props.firstTime){
  this.props.updateFirstTime(false);
}



}

  render() {
    const firstTime = this.state.firstTime;
    let content;

    if(firstTime){
      content = <Greetings handler={this.handler}/>
    }

    else{
      content = <ItemPicker handler={this.handler} query={this.props.query} items={this.props.json} />
    }


    return (
    <React.Fragment>
     {content}
    </React.Fragment>
    )
  }
}

export default Home;
